import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../components/Loading';
import {getLastData } from '../helpers/registrationHelper';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_id: props.user_id
    }

  }

  componentDidMount() {
    let id = this.state.user_id ? this.state.user_id : localStorage.getItem('user_id')
    getLastData(id)
      .then((data) => {
        this.setState({ measuresValue: data.data });
      })

  }

  
  getEnergyIcon(value) {
    value = parseInt(value);
    switch (value) {
      case 0:
      return (<img alt="energy" src={require("../images/Energy_Icon-0.png")} />)
      case 1:
      return (<img alt="energy" src={require("../images/Energy_Icon-1.png")} />)
      case 2:
      return (<img alt="energy" src={require("../images/Energy_Icon-2.png")} />)
      default:
      return (<img alt="energy" src={require("../images/Energy_Icon-0.png")} />)
    }
  }
  
  getMoodIcon(value) {
    value = parseInt(value);
    switch (value) {
      case 0:
      return (<img alt="mood" src={require("../images/Mood_Icon-0.png")} />)
      case 1:
      return (<img alt="mood" src={require("../images/Mood_Icon-1.png")} />)
      case 2:
      return (<img  alt="mood" src={require("../images/Mood_Icon-2.png")} />)
      default:
      return (<img  alt="mood" src={require("../images/Mood_Icon-0.png")} />)
    }
  }
  
  setMeasureType = (url) => {
    switch (url.split('/')[url.split('/').length - 1]) {
      case 'heart-rate': return 2;
      case 'breath-rate': return 6;
      case 'blood-pressure': return 1;//1-8 
      case 'mood': return 5;
      case 'energy': return 4;
      case 'sleep': return 3;
      case 'ecg': return 7;
      case 'calories': return 9;
      case 'steps': return 10;
      default: console.log('no measure_type_id for this path'); break;
    }
  }

  handleClick(url) {
    const { history } = this.props;
    history ? history.push(url) : this.props.itemSelected(this.setMeasureType(url))
  }

  render() {
    const LastValue = () => (
      <p>last value</p>
    )
    
    if (!this.state.measuresValue) {
      return <Loading />
    }

    return (
      <div className="page-container">
        <div className="measure-box-container">
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/heart-rate') }}>
              <img src={require("../images/Heart_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Heart rate
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["2"].value}
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/breath-rate') }}>
              <img src={require("../images/Breath_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Breath rate
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["6"].value}
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/blood-pressure') }}>
              <img src={require("../images/BloodPressure_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Blood pressure
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["1"].value}
                /{this.state.measuresValue["8"].value}
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/mood') }}>
              {this.getMoodIcon(this.state.measuresValue["5"].value)}
              <div className="titleContainer">
                <div className="title">
                  Mood
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/energy') }}>
              {this.getEnergyIcon(this.state.measuresValue["4"].value)}
              <div className="titleContainer">
                <div className="title">
                  Energy
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('/measures/sleep') }}>
              <img src={require("../images/Sleep_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Sleep
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["3"].value}
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick('measures/calories') }}>
              <img src={require("../images/Calory_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Calories
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["9"].value}
              </div>
            </a>
          </div>
          <div className="measure-box">
            <a onClick={() => { this.handleClick() }}>
              <img src={require("../images/Steps_Icon.png")} />
              <div className="titleContainer">
                <div className="title">
                  Steps
                </div>
                <LastValue />
              </div>
              <div className="measure-box-value">
                {this.state.measuresValue["10"].value}
              </div>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

Dashboard.propTypes = {
  history: PropTypes.object,
  props: PropTypes.object,
  user_id: PropTypes.number,
  itemSelected: PropTypes.func,
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/view/dashboard.js